import { apiSlice } from '@/api';
import { PartnerPaymentStatus, Payment } from './types';

export const paymentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPayments: builder.query<Payment[], { page: number; size: number }>({
      query: ({ page, size }) => ({
        url: `v1/payment/all?page=${page}&size=${size}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment[] }) => response.result,
    }),
    getPartnersPaymentsById: builder.query<Payment, { id: string }>({
      query: ({ id }) => ({
        url: `v1/payment/partner/${id}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment }) => response.result,
      providesTags: (_, __, { id }) => [{ type: 'Payment', id }],
    }),
    uploadPaymentInvoice: builder.mutation<void, { id: string; file: File }>({
      query: ({ id, file }) => {
        const formData = new FormData();
        formData.append('file', file);

        return {
          url: `v1/payment/${id}/upload-invoice`,
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: (_, __, { id }) => [{ type: 'Payment', id }, 'Payment'],
    }),
    getPaymentsPartner: builder.query<
      Payment[],
      { page: number; size: number; status?: PartnerPaymentStatus }
    >({
      query: ({ page, size }) => ({
        url: `v1/payment/partner/all?page=${page}&size=${size}`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment[] }) => response.result,
      providesTags: ['Payment'],
    }),
    getPaymentsPartnerTotalSum: builder.query<
      { amount: number; bonus: number },
      void
    >({
      query: () => ({
        url: `v1/payment/partner/total`,
        method: 'GET',
      }),
      transformResponse: (response: {
        result: { amount: number; bonus: number };
      }) => response.result,
    }),
    getPaymentsPartnerLastMonth: builder.query<Payment, void>({
      query: () => ({
        url: `v1/payment/partner/last`,
        method: 'GET',
      }),
      transformResponse: (response: { result: Payment }) => response.result,
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useGetPartnersPaymentsByIdQuery,
  useUploadPaymentInvoiceMutation,
  useGetPaymentsPartnerQuery,
  useGetPaymentsPartnerTotalSumQuery,
  useGetPaymentsPartnerLastMonthQuery,
} = paymentsApi;
